import { ref as u, computed as d, onMounted as _, nextTick as x, onBeforeUnmount as ee, provide as te, withDirectives as ne, openBlock as i, createElementBlock as f, toDisplayString as oe, createCommentVNode as a, createBlock as c, createElementVNode as v, normalizeClass as T, createVNode as le, unref as k, withCtx as E, Teleport as ie } from "vue";
import ae from "smoothscroll-polyfill";
import D from "./on-page-navigation-list.vue.js";
/* empty css                        */
import P from "../../molecules/dropdown/dropdown.vue.js";
import R from "../../molecules/link/link.vue.js";
import { resizeAwds as se } from "../../utils/directives/resize.js";
const re = {
  key: 0,
  class: "on-page-nav"
}, ue = {
  key: 0,
  class: "ds-text ds-font-weight-bold ds-margin-bottom-12"
}, de = {
  key: 1,
  class: "on-page-nav on-page-nav--full-screen"
}, ce = { class: "on-page-nav__horizontal ds-container" }, ve = {
  key: 0,
  class: "on-page-nav__horizontal__nav-wrapper"
}, me = { class: "on-page-nav on-page-nav--full-screen ds-display-flex ds-align-items-center ds-justify-content-space-between" }, fe = {
  class: "on-page-nav__screen-small__dropdown-wrapper",
  "data-j-wrapper": ""
}, ge = {
  key: 0,
  class: "on-page-nav__screen-small__button-wrapper"
}, q = 72, H = 62, we = /* @__PURE__ */ Object.assign({
  name: "DsOnPageNavigation"
}, {
  __name: "on-page-navigation",
  props: {
    useGrid: {
      type: Boolean,
      default: !0
    },
    disposition: {
      type: String,
      required: !0,
      validator: (t) => ["vertical", "horizontal"].includes(t)
    },
    initialActiveItem: {
      type: String,
      default: ""
    },
    portalTarget: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      required: !0
    },
    screen: {
      type: String,
      required: !0
    },
    items: {
      type: Array,
      required: !0
    },
    showNumbers: {
      type: Boolean,
      default: !1
    },
    updateRoute: {
      type: Boolean,
      default: !0
    },
    offsetScrollTop: {
      type: Number,
      default: 0
    },
    button: {
      type: Object,
      default: null
    }
  },
  emits: ["item-clicked"],
  setup(t, { emit: L }) {
    const j = se(), m = u([]), I = u(null), g = u(null), w = u(!1), b = u(null), z = u(0), O = u(), S = u(!1), A = L, l = t, h = d(() => l.disposition === "vertical"), s = d(() => l.items.map((e, n) => ({
      ...e,
      active: e.slug === G.value,
      label: l.showNumbers ? `${n + 1}. ${e.label}` : e.label
    }))), G = d(() => {
      var e;
      return (e = m.value[m.value.length - 1]) == null ? void 0 : e.id;
    }), V = d(() => l.items.map(({ slug: e }) => document.querySelector([`[data-id="${e}"]`]) || null)), N = d(() => {
      const e = s.value.find((n) => n.active);
      return e ? e.label.length > 19 && l.screen === "small" && l.button ? `${e.label.slice(0, 16)}...` : e.label : "";
    }), M = d(() => l.button.title.length > 13 ? `${l.button.title.slice(0, 10)}...` : l.button.title), $ = d(() => {
      const e = s.value.length;
      return e <= 6 ? `${e * H}` : "300";
    }), W = d(() => h.value ? l.screen !== "large" : l.screen === "small");
    _(async () => {
      var e;
      ae.polyfill(), S.value = !0, z.value = (e = O.value) != null && e.$el && typeof window < "u" ? getComputedStyle(O.value.$el, "::before").width.split("px")[0] : 0, await x(), F(), !h.value && l.screen !== "small" && C(), setTimeout(() => {
        l.initialActiveItem && l.updateRoute && y({ slug: l.initialActiveItem.replace("#", "") });
      }, 1e3);
    }), ee(() => {
      var e, n;
      I.value && ((e = I.value) == null || e.disconnect()), g.value && ((n = g.value) == null || n.disconnect());
    });
    const F = () => {
      I.value = new IntersectionObserver(Y, {
        rootMargin: "0px",
        // rootMargin: '0px 0px -50% 0px', // @TODO option to observe half of the viewport to tryout in a possible refactor
        threshold: [0, 0.01, 0.05, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
      }), U();
    }, U = () => {
      V.value.forEach((e) => I.value.observe(e));
    }, Y = (e, n) => {
      e.forEach((o) => {
        J(o.target.dataset.id), o.isIntersecting && m.value.push({ id: o.target.dataset.id, ratio: o.intersectionRatio });
      }), m.value.sort((o, r) => o.ratio - r.ratio);
    }, J = (e) => {
      m.value = m.value.filter((n) => n.id !== e);
    }, B = async (e) => {
      const n = s.value.findIndex((o) => o.active);
      await x(), e && e(H * n);
    }, C = () => {
      var n;
      g.value = new IntersectionObserver(K, {
        root: document.querySelector(".list--horizontal"),
        rootMargin: "0px",
        threshold: 1
      });
      const e = document.querySelector(".list--horizontal .list__item:last-child");
      (n = g.value) == null || n.observe(e);
    }, K = (e, n) => {
      var r, p;
      const o = ((r = e == null ? void 0 : e[0]) == null ? void 0 : r.isIntersecting) === !1;
      o && !b.value && (b.value = typeof window < "u" ? window.innerWidth - z.value : 0, (p = g.value) == null || p.disconnect()), w.value = o;
    }, Q = async (e) => {
      b.value && e > b.value && (b.value = null, w.value = !1), !h.value && l.screen !== "small" && !w.value && (await x(), C());
    }, y = async (e, n) => {
      const o = document.querySelector([`[data-id="${e.slug}"]`]) || null;
      if (o) {
        const r = document.documentElement.scrollTop, p = o.getBoundingClientRect().top + window.scrollY, X = Number(
          p < r ? q * 2 + l.offsetScrollTop : q + l.offsetScrollTop
        ), Z = Number(p - X);
        n && n({ text: e.label }), typeof window < "u" && setTimeout(() => {
          window.scrollTo({
            left: 0,
            top: Z,
            behavior: "smooth"
          });
        }, 1), location.hash !== `#${e.slug}` && l.updateRoute && (await x(), location.hash = e.slug), typeof window < "u" && A("item-clicked", { url: `${window.location.href + "#" + e.slug}`, label: e.label });
      }
    };
    return te("trackingData", { trackingData: { "component-name": "DsOnPageNavigation", title: l.title } }), (e, n) => ne((i(), f("div", null, [
      t.screen === "large" & h.value ? (i(), f("div", re, [
        t.title ? (i(), f("h2", ue, oe(t.title), 1)) : a("", !0),
        s.value.length ? (i(), c(D, {
          key: 1,
          items: s.value,
          disposition: t.disposition,
          "small-text": "",
          onClickedItem: y
        }, null, 8, ["items", "disposition"])) : a("", !0)
      ])) : a("", !0),
      t.screen !== "small" && !h.value ? (i(), f("div", de, [
        v("div", ce, [
          v("div", {
            class: T({ "ds-grid": t.useGrid })
          }, [
            v("div", {
              class: T({
                "ds-grid__col ds-grid__col--12": t.useGrid,
                "ds-display-flex ds-justify-content-space-between ds-align-items-center": t.button
              })
            }, [
              !w.value && s.value.length ? (i(), f("div", ve, [
                le(D, {
                  items: s.value,
                  disposition: t.disposition,
                  onClickedItem: y
                }, null, 8, ["items", "disposition"])
              ])) : a("", !0),
              w.value ? (i(), c(k(P), {
                key: `dropDown${e.$.vnode.key}`,
                label: t.title,
                text: N.value || t.title,
                width: "275px",
                height: $.value,
                onDropdownOpened: n[0] || (n[0] = ({ setScrollTop: o }) => B(o))
              }, {
                default: E((o) => [
                  s.value.length ? (i(), c(D, {
                    key: 0,
                    items: s.value,
                    disposition: "vertical",
                    onClickedItem: (r) => y(r, o.close)
                  }, null, 8, ["items", "onClickedItem"])) : a("", !0)
                ]),
                _: 1
              }, 8, ["label", "text", "height"])) : a("", !0),
              t.button ? (i(), c(k(R), {
                key: 2,
                ref_key: "OnPageNavButton",
                ref: O,
                type: "button",
                "tracking-data": { "component-name": "DsOnPageNavigation", text: t.button.title, title: t.title },
                url: t.button.url,
                "lazy-url-endpoint": t.button.lazyUrlEndpoint,
                "open-in-new-window": t.button.openInNewWindow,
                download: t.button.download,
                nuxt: t.button.nuxt,
                content: t.button.title,
                "icon-left": t.button.download ? { category: "arrows", name: "download" } : null,
                class: "on-page-nav__horizontal__button ds-button ds-button--primary",
                "data-j-button": ""
              }, null, 8, ["tracking-data", "url", "lazy-url-endpoint", "open-in-new-window", "download", "nuxt", "content", "icon-left"])) : a("", !0)
            ], 2)
          ], 2)
        ])
      ])) : a("", !0),
      W.value && S.value ? (i(), c(ie, {
        key: 2,
        to: t.portalTarget
      }, [
        v("div", me, [
          v("div", fe, [
            v("div", {
              class: T({ "ds-grid": t.useGrid })
            }, [
              v("div", {
                class: T({ "ds-grid__col ds-grid__col--12": t.useGrid })
              }, [
                (i(), c(k(P), {
                  key: `dropDown${e.$.vnode.key}`,
                  "tracking-data": { "component-name": "DsOnPageNavigation" },
                  text: N.value || t.title,
                  label: t.title,
                  height: $.value,
                  width: "100%",
                  "full-screen": "",
                  onDropdownOpened: n[1] || (n[1] = ({ setScrollTop: o }) => B(o))
                }, {
                  default: E((o) => [
                    s.value.length ? (i(), c(D, {
                      key: 0,
                      items: s.value,
                      disposition: "vertical",
                      onClickedItem: (r) => y(r, o.close)
                    }, null, 8, ["items", "onClickedItem"])) : a("", !0)
                  ]),
                  _: 1
                }, 8, ["text", "label", "height"]))
              ], 2)
            ], 2)
          ]),
          t.button ? (i(), f("div", ge, [
            t.button ? (i(), c(k(R), {
              key: 0,
              ref_key: "OnPageNavButton",
              ref: O,
              type: "button",
              "tracking-data": { "component-name": "DsOnPageNavigation", text: t.button.title, title: t.title },
              url: t.button.url,
              "lazy-url-endpoint": t.button.lazyUrlEndpoint,
              "open-in-new-window": t.button.openInNewWindow,
              nuxt: t.button.nuxt,
              download: t.button.download,
              content: M.value,
              "icon-left": t.button.download && t.screen !== "small" ? { category: "arrows", name: "download" } : null,
              class: "on-page-nav__screen-small__button ds-button ds-button--primary",
              "data-j-button": ""
            }, null, 8, ["tracking-data", "url", "lazy-url-endpoint", "open-in-new-window", "nuxt", "download", "content", "icon-left"])) : a("", !0)
          ])) : a("", !0)
        ])
      ], 8, ["to"])) : a("", !0)
    ])), [
      [k(j), Q]
    ]);
  }
}), xe = we;
export {
  xe as default
};
